<template src="../templates/normal_fcont_125.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '125',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,AppDownloadPhotoPlusJp
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['125-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['125-2']}
    ]};
  }
  
};
</script>
<style >
</style>

